module.exports = __webpack_public_path__ + "media/media/product-card/_vlsat_pro_empty-9efd4a597cdcf736c8ed29e7364f2252.jpg";